module.exports = __webpack_public_path__ + "static/media/1.677113e3.png";